import React, { FunctionComponent, HTMLAttributes } from 'react';

const Logo: FunctionComponent<HTMLAttributes<HTMLImageElement>> = (
  props: HTMLAttributes<HTMLImageElement>,
) => (
  <img
    alt="Logo"
    src="/img/new_logo_cdtec_blue.png"
    {...props}
  />
);

export default Logo;
